import { Component, OnDestroy, OnInit, Type } from "@angular/core";
import { first, map, tap, toArray } from "rxjs/operators";
import { CirculationFacade } from "src/app/services/circulation.facade";
import { SubSink } from "subsink";
import { IStepTypeProviderDescription } from "../../interfaces";
import { CirculationId } from "../../interfaces/circulation";
import { LogClass, Logger } from "../../logger";
import { NavigationService } from "../../services/navigation.service";
import { StepFacade } from "../services/step.facade";

@Component({
    selector: "circ-new-step",
    templateUrl: "./new-step.component.html",
    styleUrls: ["./new-step.component.scss"],
    standalone: false
})
@LogClass({ source: "NewStepComponent" })
export class NewStepComponent implements OnInit, OnDestroy {
  public loading = true;
  public providerComponent: Type<unknown>;
  public providers: IStepTypeProviderDescription[];

  private _selectedProvider: IStepTypeProviderDescription;
  private circulationId: CirculationId;
  private logger: Logger;
  private subscriptions = new SubSink();

  constructor(
    private navigate: NavigationService,
    private circulationFacade: CirculationFacade,
    private stepFacade: StepFacade
  ) {
    this.logger.debug("ctor");
  }

  public get selectedProvider(): IStepTypeProviderDescription {
    return this._selectedProvider;
  }

  public set selectedProvider(value: IStepTypeProviderDescription) {
    this._selectedProvider = value;
    this.providerComponent = value?.createComponent;
  }

  public abort(): void {
    this.navigate.toCirculation(this.circulationId);
  }

  public ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  public ngOnInit(): void {
    this.logger.info("init");
    this.stepFacade
      .getTypes()
      .pipe(toArray(), first())
      .subscribe((providers) => {
        this.providers = providers;
        this.selectedProvider = this.providers[0]; // always one there..
      });

    this.subscriptions.sink = this.circulationFacade
      .getCurrentCirculation()
      .pipe(
        map((circ) => circ.id),
        tap((id) => (this.circulationId = id))
      )
      .subscribe(() => (this.loading = false));
  }
}
